<template>
  <DefaultLayout class="overflow-hidden">
    <router-view />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from './default-layout.vue'
export default {
  components: { DefaultLayout },
}
</script>
